// extracted by mini-css-extract-plugin
export default {"menu":"SidebarItems_menu__C3kSc","sidebar_menu":"SidebarItems_sidebar_menu__SPZoE","submenu":"SidebarItems_submenu__OoSvt","active":"SidebarItems_active__5Edam"};